<template>
  <div className="text-base text-black bg-white dark:bg-zinc-900 dark:text-zinc-300">
    <Toast />
    <router-view />
  </div>
  <ModalsContainer />
</template>

<script lang="ts" setup>
import { onBeforeMount } from 'vue';

import Toast from './components/toast/Toast.vue';
import { ModalsContainer } from 'vue-final-modal';

onBeforeMount(() => {
  document.getElementsByTagName('body')[0].className = 'bg-white dark:bg-zinc-900';
});
</script>
